import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'shuntingCustomer': {
    title: '分流经销商编号',
    type: 'input',
    equation: cusname,
    width: 150
  },
  'shuntingCustomerName': {
    title: '分流经销商名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'channels': {
    describe: true,
    title: '渠道类型',
    type: 'select',
    equation: all,
    dictionary: 'A0054',
    width: 120
  }
}

export default {
  'shuntingCustomerName': {
    title: '分流经销商名称',
    width: 250
  },
  'shuntingCustomer': {
    title: '分流经销商编号',
    width: 150
  },
  'channelsTextView': {
    title: '渠道',
    width: 120
  }
}




// WEBPACK FOOTER //
// ./src/components/dialog/config/ShuntDealerSelect.js